module.exports = __webpack_public_path__ + "static/media/profile-pic05.87f9890e.png";